// validate in all pages if the cache is still relevant before using it 
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Cache-Control#directives

export default defineNuxtRouteMiddleware(() => {

  if (import.meta.server) {

    const cacheControlHeader = useResponseHeader('Cache-Control');
    cacheControlHeader.value = 'no-cache';
  
  }

});